"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionAPI = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const BaseAPI_1 = require("./BaseAPI");
class CollectionAPI extends BaseAPI_1.BaseAPI {
    get executeType() {
        return ExecuteCommand;
    }
    get queryType() {
        return QueryCommand;
    }
}
exports.CollectionAPI = CollectionAPI;
class ExecuteCommand {
    setTxShares({ contract, data, sender }) {
        return {
            label: "Set transaction shares",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                set_tx_shares: data
            })
        };
    }
    setMintShares({ contract, data, sender }) {
        return {
            label: "Set mint shares",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                set_mint_shares: data
            })
        };
    }
    mint({ contract, data, sender }, asset) {
        const mintMsg = {
            mint: data
        };
        let msg;
        if (asset.coin) {
            msg = new terra_js_1.MsgExecuteContract(sender, contract, mintMsg, [new terra_js_1.Coin(asset.coin.denom, asset.coin.amount)]);
        }
        if (asset.token) {
            msg = new terra_js_1.MsgExecuteContract(sender, asset.token.address, {
                send: {
                    msg: Buffer.from(JSON.stringify(mintMsg)).toString("base64"),
                    amount: asset.token.amount,
                    contract: contract
                }
            });
        }
        return {
            label: "Mint NFT",
            msg
        };
    }
    sell({ contract, data, sender }) {
        return {
            label: "Sell NFT",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                sell: data
            })
        };
    }
    cancelSell({ contract, data, sender }) {
        return {
            label: "Cancel Sell NFT",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                cancel_sell: data
            })
        };
    }
    buy({ contract, data, sender }, asset) {
        const buyMsg = {
            buy: data
        };
        let msg;
        if (asset.coin) {
            msg = new terra_js_1.MsgExecuteContract(sender, contract, buyMsg, [new terra_js_1.Coin(asset.coin.denom, asset.coin.amount)]);
        }
        if (asset.token) {
            msg = new terra_js_1.MsgExecuteContract(sender, asset.token.address, {
                send: {
                    msg: Buffer.from(JSON.stringify(buyMsg)).toString("base64"),
                    amount: asset.token.amount,
                    contract: contract
                }
            });
        }
        return {
            label: "Buy NFT",
            msg
        };
    }
    bid({ contract, data, sender }, asset) {
        const bidMsg = {
            bid: data
        };
        let msg;
        if (asset.coin) {
            msg = new terra_js_1.MsgExecuteContract(sender, contract, bidMsg, [new terra_js_1.Coin(asset.coin.denom, asset.coin.amount)]);
        }
        if (asset.token) {
            msg = new terra_js_1.MsgExecuteContract(sender, asset.token.address, {
                send: {
                    msg: Buffer.from(JSON.stringify(bidMsg)).toString("base64"),
                    amount: asset.token.amount,
                    contract: contract
                }
            });
        }
        return {
            label: "Bid NFT",
            msg
        };
    }
    withdrawBid({ contract, data, sender }) {
        return {
            label: "Withdraw bid NFT",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                withdraw_bid: data
            })
        };
    }
    acceptBid({ contract, data, sender }) {
        return {
            label: "Accept bid NFT",
            msg: new terra_js_1.MsgExecuteContract(sender, contract, {
                accept_bid: data
            })
        };
    }
}
class QueryCommand extends BaseAPI_1.BaseQueryCommand {
    generateVoucher({ contract, data }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.lcd.wasm.contractQuery(contract, { generate_voucher: data });
        });
    }
    sellInfo({ contract, data }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.lcd.wasm.contractQuery(contract, { sell_info: data });
        });
    }
    bidByBuyer({ contract, data }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.lcd.wasm.contractQuery(contract, { bid_by_buyer: data });
        });
    }
    bidByNft({ contract, data }) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.lcd.wasm.contractQuery(contract, { bid_by_nft: data });
        });
    }
}
